<template>
  <div style="width: 100%">
    <a-menu
      mode="inline"
      theme="light"
      v-model:selectedKeys="selectedKeys"
      v-model:openKeys="openKeys"
      @select="onclick"
    >
      <a-sub-menu key="dashboard-group">
        <template #icon><HomeOutlined /></template>
        <template #title>仪表盘</template>
        <a-menu-item key="user-dashboard">
          <span>用户仪表盘</span>
        </a-menu-item>
        <a-menu-item v-if="canViewStats" key="dashboard">
          <span>请求仪表盘</span>
        </a-menu-item>
      </a-sub-menu>

      <a-sub-menu key="tiku-group">
        <template #icon><AppstoreOutlined /></template>
        <template #title>题库中心</template>
        <a-menu-item key="component">
          <span>题库总览</span>
        </a-menu-item>
        <a-menu-item key="notebooks">
          <span>笔记本</span>
        </a-menu-item>
        <a-menu-item key="import">
          <span>智能导入</span>
        </a-menu-item>
      </a-sub-menu>

      <template v-if="showAdminGroup">
        <a-sub-menu key="admin-group">
          <template #icon><SettingOutlined /></template>
          <template #title>管理中心</template>
          <a-menu-item v-if="canManageUsers" key="userlist">
            <span>用户列表</span>
          </a-menu-item>
          <a-menu-item v-if="canManageRequests" key="requests">
            <span>申请管理</span>
          </a-menu-item>
          <a-menu-item v-if="canManageProviders" key="providers">
            <span>题库/AI 配置</span>
          </a-menu-item>
          <a-menu-item v-if="canManageSettings" key="system-config">
            <span>系统设置</span>
          </a-menu-item>
        </a-sub-menu>

        <a-sub-menu v-if="showLogGroup" key="log-group">
          <template #icon><FileTextOutlined /></template>
          <template #title>日志审计</template>
          <a-menu-item v-if="canReadAudit" key="audit-log">
            <span>审计日志</span>
          </a-menu-item>
          <a-menu-item v-if="canReadRequests" key="request-log">
            <span>请求日志</span>
          </a-menu-item>
          <a-menu-item v-if="canReadLogs" key="loglist">
            <span>系统日志</span>
          </a-menu-item>
        </a-sub-menu>
      </template>
    </a-menu>
  </div>
</template>
<script>
import { defineComponent, ref, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { hasAnyPermission, hasPermission, PERMISSIONS } from '@/utils/permissions'
import {
  HomeOutlined,
  FileTextOutlined,
  AppstoreOutlined,
  SettingOutlined
} from '@ant-design/icons-vue'
export default defineComponent({
  name: 'SiderMenu',
  setup() {
    const router = useRouter()
    const route = useRoute()
    const selectedKeys = ref([route.name])
    const openKeys = ref([])
    const navigateToImport = (key) => {
      router.push(`/adapter/${key}`)
    }
    const canViewStats = hasPermission(PERMISSIONS.REQUEST_LOG_STATS_READ)
    const canManageUsers = hasPermission(PERMISSIONS.USER_MANAGE)
    const canManageRequests = hasPermission(PERMISSIONS.REQUEST_REVIEW)
    const canManageProviders = hasAnyPermission([PERMISSIONS.PROVIDER_MANAGE, PERMISSIONS.PRICING_MANAGE])
    const canManageSettings = hasAnyPermission([PERMISSIONS.SEARCH_ORDER_MANAGE, PERMISSIONS.SYSTEM_CONFIG_READ, PERMISSIONS.SYSTEM_CONFIG_WRITE])
    const canReadAudit = hasPermission(PERMISSIONS.AUDIT_LOG_READ)
    const canReadRequests = hasPermission(PERMISSIONS.REQUEST_LOG_READ)
    const canReadLogs = hasPermission(PERMISSIONS.LOG_READ)
    const showAdminGroup = canManageUsers || canManageRequests || canManageProviders || canManageSettings
    const showLogGroup = canReadAudit || canReadRequests || canReadLogs

    const routeMap = {
      'user-dashboard': 'dashboard-group',
      'dashboard': 'dashboard-group',
      'component': 'tiku-group',
      'notebooks': 'tiku-group',
      'import': 'tiku-group',
      'userlist': 'admin-group',
      'requests': 'admin-group',
      'providers': 'admin-group',
      'system-config': 'admin-group',
      'audit-log': 'log-group',
      'request-log': 'log-group',
      'loglist': 'log-group'
    }

    const updateMenuState = (path) => {
      const pathSegments = path.split('/')
      const key = pathSegments[pathSegments.length - 1]
      selectedKeys.value = [key]
      const group = routeMap[key]
      if (group && !openKeys.value.includes(group)) {
        openKeys.value.push(group)
      }
    }

    watch(() => route.path, (newPath) => {
      updateMenuState(newPath)
    })

    onMounted(() => {
      updateMenuState(route.path)
    })

    return {
      selectedKeys,
      openKeys,
      navigateToImport,
      canViewStats,
      canManageUsers,
      canManageRequests,
      canManageProviders,
      canManageSettings,
      canReadAudit,
      canReadRequests,
      canReadLogs,
      showAdminGroup,
      showLogGroup
    }
  },
  methods:{
    onclick (data) {
      this.selectedKeys=[data.key]
      this.navigateToImport(data.key)
    },
  },
  components: {
    HomeOutlined,
    FileTextOutlined,
    AppstoreOutlined,
    SettingOutlined
  },
})
</script>
